module.exports = __webpack_public_path__ + "static/img/icon_pro3.8c69ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_pro3.png
// module id = 9Ytw
// module chunks = 11